import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/solicitud/importer/solicitudImporterActions';

export default importerReducers(actions);
